var map = {
	"./AC.svg": "731c",
	"./AD.svg": "8de2",
	"./AE.svg": "8734",
	"./AF.svg": "8b2c",
	"./AG.svg": "0dae",
	"./AI.svg": "41a3",
	"./AL.svg": "956b",
	"./AM.svg": "90bb",
	"./AO.svg": "90bf",
	"./AQ.svg": "bf22",
	"./AR.svg": "c8fa",
	"./AS.svg": "4805",
	"./AT.svg": "626d",
	"./AU.svg": "2e5d",
	"./AW.svg": "b94e",
	"./AX.svg": "ef1f",
	"./AZ.svg": "0c91",
	"./BA.svg": "8eba",
	"./BB.svg": "53ce",
	"./BD.svg": "d0dc",
	"./BE.svg": "a1e8",
	"./BF.svg": "8e65",
	"./BG.svg": "6a2f",
	"./BH.svg": "4ab2",
	"./BI.svg": "1f82",
	"./BJ.svg": "d529",
	"./BL.svg": "2dde",
	"./BM.svg": "02a6",
	"./BN.svg": "93e6",
	"./BO.svg": "a297",
	"./BQ.svg": "026a",
	"./BR.svg": "b487",
	"./BS.svg": "be2d",
	"./BT.svg": "8d72",
	"./BV.svg": "4f30",
	"./BW.svg": "0de4",
	"./BY.svg": "853e",
	"./BZ.svg": "b16b",
	"./CA.svg": "85a7",
	"./CC.svg": "bc60",
	"./CD.svg": "15a2",
	"./CF.svg": "5302",
	"./CG.svg": "163f",
	"./CH.svg": "b46a",
	"./CI.svg": "f352",
	"./CK.svg": "da43",
	"./CL.svg": "4b4a",
	"./CM.svg": "6911",
	"./CN.svg": "abf8",
	"./CO.svg": "5b4b",
	"./CR.svg": "c806",
	"./CU.svg": "4c53",
	"./CV.svg": "dee5",
	"./CW.svg": "0eeb",
	"./CX.svg": "30bc",
	"./CY.svg": "7626",
	"./CZ.svg": "307d",
	"./DE.svg": "cdcc",
	"./DJ.svg": "2067",
	"./DK.svg": "d1ef",
	"./DM.svg": "9681",
	"./DO.svg": "7398",
	"./DZ.svg": "0b0c",
	"./EC.svg": "47aa",
	"./EE.svg": "7f83",
	"./EG.svg": "a53b",
	"./EH.svg": "7e83",
	"./ER.svg": "bf44",
	"./ES.svg": "dfc1",
	"./ET.svg": "05f8",
	"./EU.svg": "b9a8",
	"./FI.svg": "7964",
	"./FJ.svg": "7148",
	"./FK.svg": "54fb",
	"./FM.svg": "5ddf",
	"./FO.svg": "abd8",
	"./FR.svg": "7654",
	"./GA.svg": "3dd1",
	"./GB.svg": "0af4",
	"./GD.svg": "7637",
	"./GE-AB.svg": "2db7",
	"./GE-OS.svg": "d2d8",
	"./GE.svg": "7f79",
	"./GF.svg": "07cc",
	"./GG.svg": "5b22",
	"./GH.svg": "f2b3",
	"./GI.svg": "3de8",
	"./GL.svg": "e9ab",
	"./GM.svg": "b9b8",
	"./GN.svg": "bb81",
	"./GP.svg": "3230",
	"./GQ.svg": "dbbc",
	"./GR.svg": "9036",
	"./GS.svg": "c14b",
	"./GT.svg": "7de3",
	"./GU.svg": "00ff",
	"./GW.svg": "288e",
	"./GY.svg": "5005",
	"./HK.svg": "de744",
	"./HM.svg": "9d6d",
	"./HN.svg": "e753",
	"./HR.svg": "0ee4",
	"./HT.svg": "679a",
	"./HU.svg": "41aa",
	"./IC.svg": "1e28",
	"./ID.svg": "861e",
	"./IE.svg": "de3b",
	"./IL.svg": "d50b",
	"./IM.svg": "628c",
	"./IN.svg": "c7fb",
	"./IO.svg": "de20",
	"./IQ.svg": "c72c",
	"./IR.svg": "295d",
	"./IS.svg": "9d21",
	"./IT.svg": "318f",
	"./JE.svg": "590b",
	"./JM.svg": "c7ff",
	"./JO.svg": "3175",
	"./JP.svg": "e9b8",
	"./KE.svg": "621f",
	"./KG.svg": "3e24",
	"./KH.svg": "6e24",
	"./KI.svg": "28ab",
	"./KM.svg": "da51",
	"./KN.svg": "c40a",
	"./KP.svg": "2066",
	"./KR.svg": "e8b0",
	"./KW.svg": "d6a6e",
	"./KY.svg": "34fd",
	"./KZ.svg": "9558",
	"./LA.svg": "3a7b",
	"./LB.svg": "0f1c",
	"./LC.svg": "1298",
	"./LI.svg": "d637",
	"./LK.svg": "46c5",
	"./LR.svg": "c6b4",
	"./LS.svg": "625f",
	"./LT.svg": "b534",
	"./LU.svg": "ac7f",
	"./LV.svg": "26b2",
	"./LY.svg": "a032",
	"./MA.svg": "c661",
	"./MC.svg": "37d7",
	"./MD.svg": "c8ee",
	"./ME.svg": "a8f8",
	"./MF.svg": "b5ed",
	"./MG.svg": "04df",
	"./MH.svg": "f3a7",
	"./MK.svg": "3802",
	"./ML.svg": "93ff",
	"./MM.svg": "c60e",
	"./MN.svg": "e763",
	"./MO.svg": "a349",
	"./MP.svg": "bec6",
	"./MQ.svg": "9571",
	"./MR.svg": "498d",
	"./MS.svg": "609d",
	"./MT.svg": "b878",
	"./MU.svg": "c238",
	"./MV.svg": "8044",
	"./MW.svg": "e75e",
	"./MX.svg": "26e5",
	"./MY.svg": "c86b",
	"./MZ.svg": "23cd",
	"./NA.svg": "c576",
	"./NC.svg": "f8a0",
	"./NE.svg": "214d",
	"./NF.svg": "b65b",
	"./NG.svg": "44af",
	"./NI.svg": "d6fa",
	"./NL.svg": "2ea6",
	"./NO.svg": "08f8",
	"./NP.svg": "ef7c",
	"./NR.svg": "7d37",
	"./NU.svg": "89ff",
	"./NZ.svg": "1b40",
	"./OM.svg": "0394",
	"./PA.svg": "fa84",
	"./PE.svg": "6d20",
	"./PF.svg": "7cc6",
	"./PG.svg": "8476",
	"./PH.svg": "c9f7",
	"./PK.svg": "681b",
	"./PL.svg": "af97",
	"./PM.svg": "ef2a",
	"./PN.svg": "041c",
	"./PR.svg": "96f7",
	"./PS.svg": "1680",
	"./PT.svg": "d8e5",
	"./PW.svg": "bce3",
	"./PY.svg": "f205",
	"./QA.svg": "1bc9",
	"./RE.svg": "abc2",
	"./RO.svg": "560f",
	"./RS.svg": "95af",
	"./RU.svg": "d577",
	"./RW.svg": "5be7",
	"./SA.svg": "4e4b",
	"./SB.svg": "ccd6",
	"./SC.svg": "b1e7",
	"./SD.svg": "d0ce",
	"./SE.svg": "4d60",
	"./SG.svg": "6be0",
	"./SH.svg": "42e0",
	"./SI.svg": "d1f5",
	"./SJ.svg": "85e3",
	"./SK.svg": "6160",
	"./SL.svg": "a848",
	"./SM.svg": "56d2",
	"./SN.svg": "0fd9",
	"./SO.svg": "0217",
	"./SR.svg": "bf05",
	"./SS.svg": "64c2",
	"./ST.svg": "9e82",
	"./SV.svg": "3239",
	"./SX.svg": "a0eb",
	"./SY.svg": "bfb9",
	"./SZ.svg": "9c6be",
	"./TA.svg": "2002",
	"./TC.svg": "5351",
	"./TD.svg": "9892",
	"./TF.svg": "ebab",
	"./TG.svg": "604a",
	"./TH.svg": "526c",
	"./TJ.svg": "2ea1",
	"./TK.svg": "5e7b",
	"./TL.svg": "fc78",
	"./TM.svg": "7443",
	"./TN.svg": "092d",
	"./TO.svg": "060c",
	"./TR.svg": "fc52",
	"./TT.svg": "51e6",
	"./TV.svg": "097f",
	"./TW.svg": "cb3f",
	"./TZ.svg": "ed18",
	"./UA.svg": "8b87",
	"./UG.svg": "01c7",
	"./UM.svg": "d052",
	"./US.svg": "9861",
	"./UY.svg": "b137",
	"./UZ.svg": "bd76",
	"./VA.svg": "9f57",
	"./VC.svg": "3464",
	"./VE.svg": "f67c",
	"./VG.svg": "b091",
	"./VI.svg": "39f4",
	"./VN.svg": "e71e",
	"./VU.svg": "00db",
	"./WF.svg": "7bd0",
	"./WS.svg": "ccb2",
	"./XK.svg": "1ea1",
	"./YE.svg": "a756",
	"./YT.svg": "9eec",
	"./ZA.svg": "8939",
	"./ZM.svg": "a60a",
	"./ZW.svg": "d66c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ba2";